import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EvaluationComponent } from './components/evaluation.component';


const routes: Routes = [
  { path: '', component: EvaluationComponent },
];

export const routedComponents: any[] = [
  EvaluationComponent,
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EvaluationRoutingModule { }
